// /src/pages/admin/clientes/MapaClientes.jsx

import React, { useState, useEffect, useMemo } from "react";
import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  InfoWindow,
} from "@react-google-maps/api";
import axios from "../../../api/axios";

const containerStyle = {
  width: "100%",
  height: "80vh",
};

export default function MapaClientes() {

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [loading, setLoading] = useState(true);

  const center = useMemo(() => {
    if (clientes.length > 0) {
      return {
        lat: parseFloat(clientes[0].latitud),
        lng: parseFloat(clientes[0].longitud),
      };
    }
    return { lat: -1.2884, lng: -78.6167 };
  }, [clientes]);

  useEffect(() => {
    const fetchClientesInstalados = async () => {
      setLoading(true);
      try {
        // 👇 OBTENER DE CUSTOMERS, NO DE INSTALLATIONS
        const res = await axios.get("/customers");
        
        // Filtrar solo clientes ACTIVOS que tengan coordenadas
        const clientesConCoords = res.data.filter(
          (c) =>
            c.estado === "ACTIVO" &&
            c.latitud &&
            c.longitud &&
            !isNaN(parseFloat(c.latitud)) &&
            !isNaN(parseFloat(c.longitud))
        );

        console.log("Clientes activos con coordenadas:", clientesConCoords.length);
        setClientes(clientesConCoords);

      } catch (err) {
        console.error("Error al cargar clientes:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClientesInstalados();
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto p-4 text-center">
        <div className="animate-spin h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full mx-auto"></div>
        <p className="mt-4">Cargando mapa de clientes...</p>
      </div>
    );
  }

  if (clientes.length === 0) {
    return (
      <div className="container mx-auto p-4">
        <h1 className="text-xl font-bold mb-4">Mapa de Clientes Instalados</h1>
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 p-8 rounded-lg text-center">
          <p className="text-lg mb-2">No hay clientes con ubicación</p>
          <p className="text-sm">
            Los clientes instalados aparecerán aquí cuando tengan coordenadas válidas.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-xl font-bold mb-4">
        Mapa de Clientes Instalados ({clientes.length})
      </h1>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={12}
      >
        <MarkerClusterer>
          {(clusterer) =>
            clientes.map((cliente) => (
              <Marker
                key={cliente.id}
                position={{
                  lat: parseFloat(cliente.latitud),
                  lng: parseFloat(cliente.longitud),
                }}
                clusterer={clusterer}
                onClick={() => setSelectedCliente(cliente)}
              />
            ))
          }
        </MarkerClusterer>

        {selectedCliente && (
          <InfoWindow
            position={{
              lat: parseFloat(selectedCliente.latitud),
              lng: parseFloat(selectedCliente.longitud),
            }}
            onCloseClick={() => setSelectedCliente(null)}
          >
            <div className="p-2 max-w-xs">
              <h2 className="font-bold text-lg">
                {selectedCliente.nombres} {selectedCliente.apellidos}
              </h2>
              <p className="text-sm mt-1">
                <span className="font-semibold">ID:</span> {selectedCliente.identificacion}
              </p>
              <p className="text-sm">
                <span className="font-semibold">Dirección:</span> {selectedCliente.direccion || 'No especificada'}
              </p>
              <p className="text-sm">
                <span className="font-semibold">Plan:</span> {selectedCliente.plan || 'N/A'}
              </p>
              <p className="text-sm">
                <span className="font-semibold">Estado:</span> 
                <span className="ml-1 px-2 py-0.5 bg-green-100 text-green-800 rounded-full text-xs">
                  {selectedCliente.estado}
                </span>
              </p>
              <button
                className="mt-2 w-full bg-blue-500 text-white text-sm py-1 px-2 rounded hover:bg-blue-600"
                onClick={() => window.open(
                  `https://www.google.com/maps/search/?api=1&query=${selectedCliente.latitud},${selectedCliente.longitud}`,
                  '_blank'
                )}
              >
                Ver en Google Maps
              </button>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
}
